import { useState } from 'react';
import { ChevronDown, Close } from 'assets/icons';
import Button from 'components/button';

const countLabel = (count) =>
  count > 1 ? `${count} modifications non enregistrées` : '1 modification non enregistrée';

/**
 * The changes of the remuneration page waiting to be saved (JBWEB-1468),
 * pinned under the cards: their count, their list on demand (each can be
 * dropped), and the two ways out. Nothing when there is none.
 */
const RemunerationChangesBar = ({ changes, onRemove, onDiscard, onSave }) => {
  const [isOpen, setIsOpen] = useState(false);
  if (!changes.length) return null;
  const refused = changes.filter((change) => change.error).length;
  return (
    <div className="sticky bottom-0 z-10 rounded-xl border border-blue-200 bg-blue-50 text-sm">
      {isOpen && (
        <ul className="divide-y divide-blue-100 border-b border-blue-200">
          {changes.map((change) => (
            <li key={change.key} className="flex items-center gap-3 px-4 py-2">
              <span className="min-w-0 flex-1 truncate text-gray-700">{change.label}</span>
              <span className="min-w-0 truncate text-right">
                {change.before && <span className="text-gray-400 line-through">{change.before}</span>}
                {change.before && <span className="px-1.5 text-gray-400">→</span>}
                <span className="font-medium text-gray-900">{change.after}</span>
                {change.error && <span className="block text-xs text-red-600">{change.error}</span>}
              </span>
              <button
                type="button"
                aria-label={`Retirer : ${change.label}`}
                className="rounded p-1 text-gray-500 hover:bg-blue-100"
                onClick={() => onRemove(change.key)}
              >
                <Close wh={14} color="currentColor" />
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="flex items-center gap-3 px-4 py-2.5">
        <button
          type="button"
          className="flex min-w-0 flex-1 items-center gap-1.5 text-left font-medium text-blue-800"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((open) => !open)}
        >
          <span className={`flex transition-transform ${isOpen ? '' : '-rotate-90'}`}>
            <ChevronDown wh={16} color="currentColor" />
          </span>
          <span className="truncate">{countLabel(changes.length)}</span>
          {refused > 0 && <span className="whitespace-nowrap text-red-600">· {refused} refusée(s)</span>}
        </button>
        <Button size="SM" color="SECONDARY" onClick={onDiscard}>
          Annuler
        </Button>
        <Button size="SM" color="PRIMARY" onClick={onSave}>
          Enregistrer
        </Button>
      </div>
    </div>
  );
};

export default RemunerationChangesBar;
